export default __webpack_public_path__ + "static/media/cornering-110.9d724933.svg";